import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, loadUser, updateProfile } from '../../redux/actions/userAction';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { UPDATE_PROFILE_RESET } from '../../redux/constants/userConstants';
import { Container, Form, InputGroup } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { AiOutlineMail, AiOutlineUser } from 'react-icons/ai';
import Loader from '../common/Loader';
import MetaData from '../MetaData';

const UpdateProfile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.user);
    const { error, isUpdated, loading } = useSelector((state) => state.profile);

    const [updatedDetails, setUpdatedDetails] = useState({
        name: '',
        email: '',
        avatar: '',
    });
    const [avatar, setAvatar] = useState();
    const [avatarPreview, setAvatarPreview] = useState('/assets/images/user.png');

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (user) {
            setUpdatedDetails({
                name: user.name,
                email: user.email,
                avatar: user.avatar.url,
            });
            setAvatarPreview(user.avatar.url);
        }
        if (isUpdated) {
            toast.success('Profile Updated Successfully');
            dispatch(loadUser());
            // to mark isUpdated = false
            dispatch({ type: UPDATE_PROFILE_RESET });
            navigate('/account');
        }
    }, [isUpdated, error, isUpdated]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateProfile({ ...updatedDetails, avatar: avatar }));
    };

    const handleInputChange = (e) => {
        if (e.target.name === 'avatar') {
            const reader = new FileReader();

            reader.onload = (e) => {
                if (reader.readyState === 2) {
                    setAvatarPreview(reader.result);
                    setAvatar(reader.result);
                }
            };

            reader.readAsDataURL(e.target.files[0]);
        } else {
            setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value });
        }
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title='Update Profile' />
            <div className='loginScreen'>
                <Container>
                    <div className='formContainer'>
                        <div className='formContentSection'>
                            <SectionHeading heading={'Update Profile'} />
                            <div className='loginRegisterForm'>
                                <form onSubmit={handleSubmit}>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineUser />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Name'
                                            aria-label='Name'
                                            name='name'
                                            value={updatedDetails.name}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineMail />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Email'
                                            aria-label='Email'
                                            name='email'
                                            value={updatedDetails.email}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <div className='registerImg'>
                                        <div className='register-img-circle'>
                                            <img src={avatarPreview} alt='Avatar Preview' />
                                        </div>
                                        <input
                                            type='file'
                                            name='avatar'
                                            accept='image/'
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <input
                                        type='submit'
                                        value='Update Profile'
                                        className='submitBtn'
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default UpdateProfile;
